import { initializeComponentLazyLoader } from '@cigna/cigna_csg_gsg_cipublic-bundle/lib/lazy.js';
import { config } from '../environments/environment';

// Lazy load with intersection observer
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const appImportMap: Iterable<[string, () => Promise<any>]> = [
  ['ciapp-personalization-wrapper', () => import('@cigna/cigna_csg_gsg_ciapp-personalization-wrapper/ciapp-personalization-wrapper.js')],
  ['ciapp-related-links', () => import('@cigna/cigna_csg_gsg_ciapp-related-links/ciapp-related-links.js')],
  ['ciapp-recently-viewed', () => import('@cigna/cigna_csg_gsg_ciapp-recently-viewed/ciapp-recently-viewed.js')],
  ['ciapp-contactus', () => import('@cigna/cigna_csg_gsg_ciapp-contactus/ciapp-contactus.js')],
  ['ciapp-claim-form', () => import('@cigna/cigna_csg_gsg_ciapp-claim-form/ciapp-claim-form.js')],
  ['ciapp-oral-health-quiz', () => import('@cigna/cigna_csg_gsg_ciapp-oral-health-quiz/ciapp-oral-health-quiz.js')],
  ['ciapp-glossary', () => import('@cigna/cigna_csg_gsg_ciapp-glossary/ciapp-glossary.js')],
  ['ciapp-search', () => import('@cigna/cigna_csg_gsg_ciapp-search/ciapp-search.js')],
  ['ciapp-shopping-wizard', () => import('@cigna/cigna_csg_gsg_ciapp-shopping-wizard/ciapp-shopping-wizard.js')],
  ['ciapp-machine-readable-files', () => import('@cigna/cigna_csg_gsg_ciapp-machine-readable-files/ciapp-machine-readable-files.js')],
  ['ciapp-generic-dropdown-link', () => import('@cigna/cigna_csg_gsg_ciapp-generic-dropdown-link/ciapp-generic-dropdown-link.js')],
  ['ciapp-ifp-picker', () => import('@cigna/cigna_csg_gsg_ciapp-ifp/ciapp-ifp.js')],
  ['ciapp-ifp-county-picker', () => import('@cigna/cigna_csg_gsg_ciapp-ifp/ciapp-ifp.js')],
  ['ciapp-ifp-plans', () => import('@cigna/cigna_csg_gsg_ciapp-ifp/ciapp-ifp.js')],
  ['ciapp-ifp-archive', () => import('@cigna/cigna_csg_gsg_ciapp-ifp-archive/ciapp-ifp-archive.js')],
  ['ciapp-medicare-lookup-tool', () => import('@cigna/cigna_csg_gsg_ciapp-medicare-lookup-tool/ciapp-medicare-lookup-tool.js')],
  [
    'ciapp-understanding-medicare-chart',
    () => import('@cigna/cigna_csg_gsg_ciapp-understanding-medicare-chart/ciapp-understanding-medicare-chart.js'),
  ],
  [
    'ciapp-understanding-medicare-card',
    () => import('@cigna/cigna_csg_gsg_ciapp-understanding-medicare-chart/ciapp-understanding-medicare-chart.js'),
  ],
  [
    'ciapp-ifp-shop-for-plans-banner',
    () => import('@cigna/cigna_csg_gsg_ciapp-ifp-shop-for-plans-banner/ciapp-ifp-shop-for-plans-banner.js'),
  ],
  ['ciapp-login-banner', () => config.flags?.enableLegacyLogin ? import('@cigna/cigna_csg_gsg_ciapp-login-banner/ciapp-login-banner-legacy.js') : import('@cigna/cigna_csg_gsg_ciapp-login-banner/ciapp-login-banner.js')],
  ['ciapp-medical-banner', () => import('@cigna/cigna_csg_gsg_ciapp-medical-banner/ciapp-medical-banner.js')],
  ['ciapp-medicare-plan-finder', () => import('@cigna/cigna_csg_gsg_ciapp-medicare-plan-finder/ciapp-medicare-plan-finder.js')],
  ['ciapp-medicare-connectus-form', () => import('@cigna/cigna_csg_gsg_ciapp-medicare-connectus-form/ciapp-medicare-connectus-form.js')],
   ['ciapp-medicare-ntm-campaign-modal', () => import('@cigna/cigna_csg_gsg_ciapp-medicare-ntm-campaign-modal/ciapp-medicare-ntm-campaign-modal.js')],
  ['ciapp-tag-page', () => import('@cigna/cigna_csg_gsg_ciapp-tag-page/ciapp-tag-page.js')],
  ['ciapp-pdl-viewer-alert', () => import('@cigna/cigna_csg_gsg_ciapp-pdl-viewer-alert/ciapp-pdl-viewer-alert.js')],
];

// This component loading logic is necessary to load components in TeamSite eStudio (preview/edit modes) correctly
export const loadComponents = () => {
  let componentLoaderInitialized = false;
  document.addEventListener('DOMContentLoaded', () => {
    initializeComponentLazyLoader(appImportMap);
    componentLoaderInitialized = true;
  });

  if (!componentLoaderInitialized) {
    initializeComponentLazyLoader(appImportMap);
  }
};
